// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFullscreenExitOutlinedSvg from "@fishx/icons-svg/es/asn/PFullscreenExitOutlined";
import FishxIcon from '../components/FishxIcon';

var PFullscreenExitOutlined = function PFullscreenExitOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFullscreenExitOutlinedSvg
  }));
};

PFullscreenExitOutlined.displayName = 'PFullscreenExitOutlined';
export default React.forwardRef(PFullscreenExitOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFullscreenExitOutlined.js
// module id = 3436
// module chunks = 0